var _defs, _line, _circle, _path, _rect, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonTemperatur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:28.35px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 440.83,
    y1: 204,
    x2: 503.83,
    y2: 204
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 355.33,
    cy: 475.5,
    r: 105.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.91,217.35a24.59,24.59,0,0,1,24.57,24.56V388.09a24.57,24.57,0,0,1-49.13,0V241.91a24.59,24.59,0,0,1,24.56-24.56m0-28.35h0A52.91,52.91,0,0,0,301,241.91V388.09A52.91,52.91,0,0,0,353.91,441h0a52.91,52.91,0,0,0,52.92-52.91V241.91A52.91,52.91,0,0,0,353.91,189Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 305.83,
    y: 285,
    width: 96,
    height: 116
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 440.83,
    y1: 273.5,
    x2: 503.83,
    y2: 273.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 440.83,
    y1: 343,
    x2: 503.83,
    y2: 343
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonTemperatur);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-temperatur.1c1e9920dc39a07d453f868a0d6e34aa.svg";
export { ForwardRef as ReactComponent };